import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/sharedModule/shared.module';
import { TrackingPageConfigurationComponent } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/components/tracking-page-configuration/tracking-page-configuration.component';
import { TrackingPageMainComponent } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/components/tracking-page-main/tracking-page-main.component';
import { TrackingPageMetricsComponent } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/components/tracking-page-metrics/tracking-page-metrics.component';
import { TrackingPageMarker } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/components/tracking-page-preview/tracking-page-marker';
import { TrackingPageStepperArrow } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/components/tracking-page-preview/tracking-page-stepper-arrow';
import { TrackingPageCouponWidgetComponent } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/components/tracking-page-widgets/tracking-page-coupon-widget/tracking-page-coupon-widget.component';
import { TrackingPageSearchWidgetComponent } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/components/tracking-page-widgets/tracking-page-search-widget/tracking-page-search-widget.component';
import { TrackingPageProductWidgetComponent } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/components/tracking-page-widgets/tracking-page-product-widget/tracking-page-product-widget.component';
import {
  HexToRgbPipe,
  MissingPrivacyMFA,
  ThemeEditorUrlPipe,
} from '@pages/checkout-app/checkout-layout/main/components/tracking-page/pipes/tracking-page.pipes';
import { TrackingPageComponent } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/tracking-page.component';
import { StorybookModule } from '@storybook/storybook.module';
import { TrackingPagePreviewComponent } from './components/tracking-page-preview/tracking-page-preview.component';
import { TrackingPageSearchPreviewComponent } from './components/tracking-page-search-preview/tracking-page-search-preview.component';
import { TrackingPageSimpleTrackerComponent } from './components/tracking-page-widgets/tracking-page-simple-tracker/tracking-page-simple-tracker.component';
import { TrackingPageTrackingDetailsComponent } from './components/tracking-page-widgets/tracking-page-tracking-details/tracking-page-tracking-details.component';
import { TrackingPageIntegrationsWidgetComponent } from '@pages/checkout-app/checkout-layout/main/components/tracking-page/components/tracking-page-widgets/tracking-page-integrations-wdiget/tracking-page-integrations-widget.component';
import { TrackingPageDeliveryPromiseComponent } from './components/tracking-page-widgets/tracking-page-delivery-promise/tracking-page-delivery-promise.component';

@NgModule({
  declarations: [
    TrackingPageComponent,
    TrackingPageMainComponent,
    TrackingPageMetricsComponent,
    TrackingPagePreviewComponent,
    TrackingPageSearchPreviewComponent,
    TrackingPageConfigurationComponent,
    TrackingPageCouponWidgetComponent,
    TrackingPageSearchWidgetComponent,
    TrackingPageSimpleTrackerComponent,
    TrackingPageTrackingDetailsComponent,
    TrackingPageProductWidgetComponent,
    HexToRgbPipe,
    ThemeEditorUrlPipe,
    TrackingPageMarker,
    TrackingPageStepperArrow,
    TrackingPageIntegrationsWidgetComponent,
    TrackingPageDeliveryPromiseComponent,
    MissingPrivacyMFA,
  ],
  providers: [DecimalPipe],
  exports: [],
  imports: [ReactiveFormsModule, FormsModule, CommonModule, SharedModule, StorybookModule],
})
export class TrackingPageModule {}
